<template>
  <v-dialog v-model="dialogDelete" max-width="600px">
    <v-card>
      <v-card-title class="text-h5 title-card">Tem certeza de que deseja excluir este item?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDelete">Cancelar</v-btn>
        <v-btn :loading="loading" dark color="primary" @click="deleteObj">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data () {
    return {
      loading: false
    }
  },
  /* eslint-disable */
    props:{
      dialogDelete: Boolean,
      objValue: Object,
    },
     methods: {
      ...mapActions('empresa', ['deleteEmpresa']),
      async deleteObj () {
        try {
          await this.deleteEmpresa(this.objValue);
        } catch (error) {
          /* eslint-disable no-console */
          console.log(error)
        } finally {
          this.$emit('closeDeleteItem')
        }
      },
      closeDelete () {
      this.$emit('closeDelete')
    }
  }
}
</script> 